import { ReactNode } from 'react';
import styles from './RadioToggleButtonFlexContainer.module.css';

interface Props {
  children: ReactNode;
}

/** A container for multiple RadioToggleButtons */
const RadioToggleButtonFlexContainer = (props: Props) => {
  return <div className={styles.container}>{props.children}</div>;
};

export default RadioToggleButtonFlexContainer;
